<div class="page full-height gray-font-color font-family bodyBackground">
  <div class="header-navigation-back">
    <mat-icon data-test="back-arrow-icon" (click)="navigateBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
    <span class="title">{{ documentTypeDisplayName || '' }}</span>
  </div>
  <div class="content" (scroll)="onScroll($event)" id="timeline-list">
    @if (uploadingNewDocument) {
    <div>
      <app-loading-gif></app-loading-gif>
    </div>
    }
    @if (!uploadingNewDocument) {
    <div>
      @if (currentTypeDocuments?.length && !showCrop && !isContentLoading) {
      <div class="container document-list-container">
        @for (document of timelineList; track document) {
        <div class="document-container" (click)="goToDocumentView(document.id)" data-test="document-list">
          <div class="document-info">
            @if (!document.fileUrl && apiCount) {
            <div class="full-width">
              <ngx-skeleton-loader appearance="line" [theme]="{
                  height: '100px',
                  width: '100%',
                  'background-color': '#c9c9c963'
                }"></ngx-skeleton-loader>
            </div>
            }
            <div class="pdf-row margin-top-md">
              @if (document.fileUrl) {
              <div class="margin-top-sm">
                <img src="assets/images/Logo.png" class="logo" />
                <span class="pdf-text margin-left-md"> {{ document.isPdf ? 'PDF Document' : 'Image'
                  }}</span>
              </div>
              }
            </div>
          </div>
          <div>
            @if (document.role === 'Driver' && document?.shipmentStopId && (document.type === 'ACIeManifest' ||
            document.type === 'ACEeManifest')) {
            <div>
              <span class="stamped-document">Stamped
                {{ document.typeDisplayName }}</span>
              <span class="date">{{ (document.createdDate | date: 'MMM d, y, h:mm a') || '' }}</span>
            </div>
            }
            @if (document.role === 'Dispatcher' && (document.type === 'ACIeManifest' || document.type ===
            'ACEeManifest')) {
            <div>
              <span class="stamped-document dispatcher-upload">
                {{ document.typeDisplayName }}</span>
              <span class="date">{{ (document.createdDate | date: 'MMM d, y, h:mm a') || '' }}</span>
            </div>
            }
            @if ((!(document.role === 'Driver' && document?.shipmentStopId && (document.type === 'ACIeManifest' ||
            document.type === 'ACEeManifest')) &&
            !(document.role === 'Dispatcher' && (document.type === 'ACIeManifest' || document.type ===
            'ACEeManifest')))) {
            <div>
              <span class="date outer-date">{{ (document.createdDate | date: 'MMM d, y, h:mm a') || '' }}</span>
            </div>
            }
          </div>
        </div>
        }
      </div>
      }
      @if (!currentTypeDocuments?.length && !showCrop && !isContentLoading) {
      <div class="container">
        @if (!showCrop && !currentTypeDocuments?.length) {
        <div class="empty-document-container">
          <div fxFlex="40">
            <img src="assets/images/file-layer.png" />
          </div>
          <div class="empty-text">
            {{ (documentTypeDisplayName | titlecase) || 'Document' }} Not Uploaded
          </div>
        </div>
        }
      </div>
      }
      @if (showCrop) {
      <div>
        @if (showCrop) {
        <div class="content">
          <div [ngClass]="{ 'image-cropper-container': !loading, 'no-height': loading }">
            <image-cropper #previewImage [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="false"
              [imageQuality]="100" [aspectRatio]="4 / 4" [roundCropper]="false" [canvasRotation]="canvasRotation"
              [transform]="transform" format="png" (imageCropped)="onImageCropped($event)"
              (imageLoaded)="onImageLoaded()" (cropperReady)="onCropperReady()" (loadImageFailed)="onLoadImageFailed()">
            </image-cropper>
            @if (!loading) {
            <div class="save-button-container full-width padding-top-x1">
              <div class="margin-bottom-xlg">
                <div class="rotate-buttons-container">
                  <button mat-raised-button class="rotate-icons" (click)="rotateLeft()">
                    <mat-icon>rotate_left</mat-icon>
                  </button>
                  <button mat-raised-button class="rotate-icons" (click)="rotateRight()">
                    <mat-icon>rotate_right</mat-icon>
                  </button>
                </div>
                <div class="action-buttons-container">
                  <button class="secondary-button" mat-raised-button (click)="onCancelCrop()"
                    data-test="cancel-button">
                    Cancel
                  </button>
                  &nbsp;
                  &nbsp;
                  <button class="primary-button" mat-raised-button
                    (click)="onFinishCrop()" data-test="finish-button">
                    Finish
                  </button>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
  @if (allowToUpload) {
  <div class="text-align-center add-row">
    <input #uploadMultiple type="file" [accept]="acceptTypesMultiple" (change)="onUploadFileChange($event)"
      data-test="add-file" />
    <input #pictureSingle type="file" name="image" [accept]="acceptTypesPicture" capture="environment"
      (change)="onProcessPictureFile($event)" data-test="add-file" />
    @if (!isContentLoading && !loading && !apiCount) {
    <button mat-button class="btn-new-document" (click)="openActionSheet(pictureSingle, uploadMultiple)"
      data-test="add-button">
      <mat-icon svgIcon="icon-file-blue"></mat-icon> + Add {{ (documentTypeDisplayName | titlecase) || '' }}
    </button>
    }
  </div>
  }
</div>